import type { SourceKind } from '../types.ts';

/**
 * The visible mark on a claim that did not come from the vendor's own site (crawl-2 §3).
 *
 * Only third-party sources get a chip. Marking first-party evidence too would make the mark
 * decoration rather than a warning — the reader's default assumption is already "the vendor said
 * this", and the whole point is to interrupt it exactly where it is wrong. The source kind rides
 * along in the label when the URL said what kind of page it was.
 */
export function SourceChip({
  thirdParty,
  sourceKind,
}: {
  thirdParty: boolean;
  sourceKind?: SourceKind;
}): JSX.Element | null {
  if (!thirdParty) return null;
  return (
    <span
      className="source-chip"
      title="Not from the vendor's own site — outside evidence about the vendor, not the vendor's own claim"
    >
      3rd-party{sourceKind ? ` · ${sourceKind}` : ''}
    </span>
  );
}
